import React, { useEffect, useState } from 'react';
import { toast } from 'sonner';

export default function WebCallVariableModal({ promptMessage, firstMessage, onSubmit, onCancel }) {
  const [fields, setFields] = useState({});
  const [variables, setVariables] = useState([]);

  useEffect(() => {
    const extractVars = (text) =>
      (text.match(/{{\s*([\w\d_]+)\s*}}/g) || []).map((v) => v.replace(/{{\s*|\s*}}/g, ''));

    const promptVars = extractVars(promptMessage);
    const firstVars = extractVars(firstMessage);
    const allVars = Array.from(new Set([...promptVars, ...firstVars]));

    setVariables(allVars);
    setFields((prev) => {
      const updated = { ...prev };
      allVars.forEach((v) => {
        if (!(v in updated)) updated[v] = '';
      });
      return updated;
    });
  }, [promptMessage, firstMessage]);

  const handleSubmit = () => {
    for (let key of variables) {
      if (!fields[key]?.trim()) {
        toast.error(`Please fill "${key}"`);
        return;
      }
    }
    onSubmit(fields);
  };

  return (
    <div className="modal-view-container">
      <div
        style={{
          backgroundColor: 'white',
          padding: '24px',
          borderRadius: '10px',
          maxWidth: '450px',
          width: '100%',
          boxShadow: '0 0 20px rgba(0,0,0,0.2)',
          overflowY: 'auto',
        }}
      >
        <div style={{ fontSize: '18px', fontWeight: 600, marginBottom: '16px' }}>
          Provide Variables for Call
        </div>

        {variables.map((v) => (
          <div key={v} style={{ marginBottom: '12px' }}>
            <label style={{ fontSize: '14px', fontWeight: 500 }}>{v}</label>
            <input
              value={fields[v]}
              onChange={(e) => setFields({ ...fields, [v]: e.target.value })}
              placeholder={`Enter ${v}`}
              style={{
                width: '100%',
                padding: '8px 10px',
                border: '1px solid #ccc',
                borderRadius: '6px',
                marginTop: '6px',
              }}
            />
          </div>
        ))}

        <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '16px', gap: '10px' }}>
          <button onClick={onCancel} style={{ padding: '8px 16px', backgroundColor: '#ccc', borderRadius: '6px' }}>
            Cancel
          </button>
          <button
            onClick={handleSubmit}
            style={{
              padding: '8px 16px',
              backgroundColor: 'var(--primary-500)',
              color: 'white',
              borderRadius: '6px',
            }}
          >
            Start Call
          </button>
        </div>
      </div>
    </div>
  );
}
